'use client';
import FAQItem from '../../../components/FAQItem';
import { useTranslations } from 'next-intl';
import get from 'lodash/get';
import { twMerge } from 'tailwind-merge';
import { COLORS } from '@/common/constants';

export default function HoiDap({ questions, locale }) {
  const t = useTranslations('');

  return (
    <>
      <h1 className={twMerge('text-2xl font-bold mb-3 uppercase', COLORS.primary)}>{t('qa.qa')}</h1>
      {get(questions, 'results', []).map((faq, idx) => (
        <FAQItem key={idx} question={locale === 'vi' ? faq.title : faq.titleEn} answer={locale === 'vi' ? faq.answers : faq.answersEn} />
      ))}
    </>
  );
}
